import React, { useState } from "react";
import { Modal, Tabs } from "antd";
import BaseButton from "../../Button/BaseButton";
import { useTranslation } from "react-i18next";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import { groupNotificationSelector } from "../../../../services/selector/index.";
import moment from "moment/moment";
import { useEffect } from "react";
import { checkNumber, isNumeric } from "../../../../utils/functionCommon";
import { IconSave } from "../../../../assets/icon";
import {
  getDetailGroupNotify,
  resetState,
  setOpenEditGroupNotification,
  updateGroupNotify,
} from "../../../../services/slice/GroupNotificationSlice";
import TabAddGroupNotification from "../../Tabs/TabAddGroupNotification";

const ModalEditGroupNotification = ({ title }) => {
  const [defaultValue, setDefaultValue] = useState("");
  const groupNotifyState = useSelector(groupNotificationSelector);
  const groupNotificationState = useSelector(groupNotificationSelector);
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { dataDetailGroupNotify } = groupNotifyState;
  const [datapost, setDataPost] = useState({});

  useEffect(() => {
    if (groupNotifyState?.idGroupNotification) {
      dispatch(getDetailGroupNotify(groupNotifyState.idGroupNotification));
    }
  }, [dispatch, groupNotifyState.idGroupNotification]);

  useEffect(() => {
    setDataPost({
      title: dataDetailGroupNotify.title,
      content: dataDetailGroupNotify.content,
      typePost: dataDetailGroupNotify.type,
      timeStart: moment(dataDetailGroupNotify.startTime).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      timeEnd: moment(dataDetailGroupNotify.endTime).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      attractGroup: dataDetailGroupNotify.attractGroupIds,
      displayRange: dataDetailGroupNotify.customerType
        ? dataDetailGroupNotify.customerType
        : 0,
      firstImage: dataDetailGroupNotify?.filename,
      attractGroupDetail: dataDetailGroupNotify.attractGroups,
      typePreferential: dataDetailGroupNotify.scope,
      redirectUrl: dataDetailGroupNotify.redirectUrl,
    });
  }, [dataDetailGroupNotify]);

  useEffect(() => {
    setDefaultValue(datapost.typePost);
  }, [datapost.typePost]);

  const handleSave = () => {
    const firstTime = new Date(datapost.timeStart).getTime();
    const secondTime = new Date(datapost.timeEnd).getTime();
    if (image.size > 2 * 1024 * 1024) {
      setError({
        isError: true,
        msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
      });
      return;
    }

    // if (
    //   datapost.typePreferential === 2 &&
    //   !isNumeric(datapost.numberCustomer)
    // ) {
    //   setError({
    //     isError: true,
    //     msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
    //   });

    //   return;
    // }
    if (secondTime - firstTime <= 0) {
      setError({
        isError: true,
        msg: "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc",
      });
      return;
    }
    if (datapost.displayRange === 1 && !datapost.attractGroup.length) {
      setError({
        isError: true,
        msg: "Nhóm khách hàng nhận ưu đãi không xác định",
      });
      return;
    }
    if (
      datapost.displayRange === 1 &&
      datapost.numberCustomer &&
      (!checkNumber(datapost.numberCustomer) || datapost.numberCustomer < 0)
    ) {
      setError({
        isError: true,
        msg: "Bạn nhập sai định dạng. Vui lòng nhập lại",
      });
      return;
    }

    const formPost = new FormData();
    const announcementDto = {
      title: datapost.title,
      startTime: moment(datapost.timeStart).format("YYYY-MM-DDTHH:mm:ssZ"),
      endTime: moment(datapost.timeEnd).format("YYYY-MM-DDTHH:mm:ssZ"),
      scope: datapost.typePreferential,
      type: datapost.typePost,
      customerType: datapost.displayRange,
      attractGroupIds:
        typeof datapost.attractGroup === "string"
          ? datapost.attractGroup.split(",").map(Number)
          : datapost.attractGroup || [],
      redirectUrl:
        datapost.typePost === 1
          ? datapost?.redirectUrl.replace(
              new RegExp(window.SERVER_URL, "g"),
              window.SERVER_CLIENT_URL
            )
          : "",
      content:
        datapost.typePost === 0
          ? datapost?.content.replace(
              new RegExp(window.SERVER_URL, "g"),
              window.SERVER_CLIENT_URL
            )
          : "",
    };
    // Gửi object JSON dưới dạng string
    formPost.append(
      "announcement",
      new Blob([JSON.stringify(announcementDto)], { type: "application/json" })
    );
    // Gửi file hình ảnh
    formPost.append("file", datapost.firstImage);
    const id = dataDetailGroupNotify?.id;
    dispatch(updateGroupNotify({ formPost, id }));
  };
  const handCancel = () => {
    dispatch(setOpenEditGroupNotification({ isOpen: false, id: "" }));
    dispatch(resetState())
  };

  const handleChangeTab = (key) => {
    setDataPost({
      ...datapost,
      typePost: parseInt(key),
    });
  };
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });

  return (
    <>
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t(title)}
        centered
        width={1300}
        open={groupNotificationState.isOpenModalEditGroupNotification}
        // onOk={() => setOpen(false)}
        onCancel={handCancel}
        footer={[
          <BaseButton
            width={96}
            content={"Lưu"}
            typeBtn="btnOrange"
            icon={<IconSave />}
            handleClick={handleSave}
          />,
        ]}
      >
        <Tabs
          key={defaultValue}
          activeKey={datapost.typePost?.toString()}
          onChange={handleChangeTab}
          defaultActiveKey={defaultValue}
          items={[
            {
              label: t("Văn bản"),
              key: "0",
              children: (
                <TabAddGroupNotification
                  // addPost={true}
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },

            {
              label: t("Hình ảnh"),
              key: "1",
              children: (
                <TabAddGroupNotification
                  // addPost={true}
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },
          ]}
        />
      </Modal>
    </>
  );
};

export default ModalEditGroupNotification;
